import Cookies from 'js-cookie';

const AUTH_TOKEN_COOKIE_NAME = 'accessToken';

export const set = (accessToken) => Cookies.set(AUTH_TOKEN_COOKIE_NAME, accessToken);

export const get = () => Cookies.get(AUTH_TOKEN_COOKIE_NAME);

export const remove = () => Cookies.remove(AUTH_TOKEN_COOKIE_NAME);